var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWithoutText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 46,
    viewBox: "0 0 72 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9667 46C33.9667 25.6408 14.9444 25.0371 14.9444 25.0371H0V33.1854H14.5863C14.5863 33.1854 25.832 33.8581 25.832 46H33.9667Z",
    fill: "#61BC18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9667 0C33.9667 20.3592 14.9444 20.9629 14.9444 20.9629H0V12.8146H14.5863C14.5863 12.8146 25.832 12.142 25.832 0H33.9667Z",
    fill: "#61BC18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0332 46C38.0332 25.6408 57.0554 25.0371 57.0554 25.0371H72V33.1854H57.4136C57.4136 33.1854 46.1678 33.8581 46.1678 46H38.0332Z",
    fill: "#61BC18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0332 0C38.0332 20.3592 57.0554 20.9629 57.0554 20.9629H72V12.8146H57.4136C57.4136 12.8146 46.1678 12.142 46.1678 0H38.0332Z",
    fill: "#AD3EF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithoutText);
export default __webpack_public_path__ + "static/media/LogoWithoutText.0a3a81343ea27fb5a72a718092076145.svg";
export { ForwardRef as ReactComponent };